module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "aboutAuthorPage"
  }, [_c('a', {
    attrs: {
      "id": "title12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Helen Brooks")]), _vm._v(" lives in Northamptonshire, England, and is married with three children. As she is a committed Christian, busy housewife and mother, her spare time is at a premium but her hobbies include reading and walking her two energetic and very endearing young dogs. Her long-cherished aspiration to write became a reality when she put pen to paper on reaching the age of forty, and sent the result off to Harlequin Mills & Boon.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f724c2dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459263314_ata01.vue
// module id = 63
// module chunks = 0